
export const channelByUser = async (props) => {
  const {
    client,
    setActiveChannel,
    user,
  } = props;

  const filters = {
    type: 'messaging',
    member_count: 2,
    members: { $eq: [user.id, client.userID || ''] },
  };

  const [existingChannel] = await client.queryChannels(filters);

  if (existingChannel) {
    return setActiveChannel(existingChannel);
  }
  const newChannel = client.channel('messaging', {
    members: [user.id, client.userID || ''], name: `${user.name || user.id} and ${(client.user && client.user.name) || client.userID}`,
    auth0_user_id: (client.user && client.user.auth0_user_id) || 'unknown'
  });
  return setActiveChannel(newChannel);
};
